import { CrudModel } from "./_crud";

export class BlogPostSubcategoryAdminModel extends CrudModel {
	constructor() {
		super("admin/blog_post_subcategory");
	}
}

export default new BlogPostSubcategoryAdminModel();
